// extracted by mini-css-extract-plugin
export var btn = "K_mB x_sN x_sz d_by d_bN d_bC d_dv";
export var full = "K_wX d_v d_G";